<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded" >
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអំពីកញ្ចប់សេវាកម្ម</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវឱ្យបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ឈ្មោះកញ្ចប់សេវាកម្ម *</label>
							<md-input type="text" v-model="package.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>សុពលភាពកញ្ចប់សេវាកម្ម *</label>
							<md-select placeholder="សុពលភាពកញ្ចប់សេវាកម្ម *" v-model="package.expiry">
								<md-option value="1">1 ខែ</md-option>
								<md-option value="2">2 ខែ</md-option>
								<md-option value="3">3 ខែ</md-option>
								<md-option value="4">4 ខែ</md-option>
								<md-option value="5">5 ខែ</md-option>
								<md-option value="6">6 ខែ</md-option>
								<md-option value="7">7 ខែ</md-option>
								<md-option value="8">8 ខែ</md-option>
								<md-option value="9">9 ខែ</md-option>
								<md-option value="10">10 ខែ</md-option>
								<md-option value="11">11 ខែ</md-option>
								<md-option value="12">12 ខែ</md-option>
							</md-select>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>កំណត់ចំណាំ</label>
							<md-input type="text" v-model="package.note"></md-input>
						</md-field>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">ឈ្មោះកញ្ចប់សេវាកម្ម</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(package.name).length > 0">{{package.name}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>សុពលភាពកញ្ចប់សេវាកម្ម</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(package.expiry).length > 0">មានសុពលភាព {{package.expiry}} ខែ</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កំណត់ចំណាំ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(package.note).length > 0">{{package.note}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updatePackage()">កែប្រែ</md-button>
			</div>
		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getPackage();
		},

		data() {
			return {
				loaded: false,
				package: {
					name: "",
					expiry: "",
					note: ""
				},
			}
		},
		methods: {
			getPackage() {
				this.$http.get(this.config.api + '/admin/package/get/' + this.$route.params.hash_id).then(data => {
					this.package.name = data.body.data.name
					this.package.note = data.body.data.note
					this.package.expiry = data.body.data.length
					this.loaded = true
				})
			},
			updatePackage() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/package/update", {
					hash_id: this.$route.params.hash_id,
					package: this.package
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ព័ត៌មានត្រូវបានកែប្រែដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
					}
					this.$router.push("/packages");

				})
			},
			checkValidation() {
				if (String(this.package.name).length > 0 && String(this.package.expiry).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.package = {
					name: "",
					expiry: "",
					note: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Package/Edit.vue